// extracted by mini-css-extract-plugin
module.exports = {"root":"LoggedOutHeader_root__KW_sY","link":"LoggedOutHeader_link__Ev1UC","headerBtn":"LoggedOutHeader_headerBtn__EAG7Q","startIcon":"LoggedOutHeader_startIcon__Yjwzz"};